import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import { isNilOrEmpty, isNilOrEmptyString } from 'ramda-extension';

import { equalOrThreeDashes } from 'utils/equalOrThreeDashes';
import { joinString } from 'utils/string';

export const Row = ({ user, onSelect, index }) => {
	const fullName = joinString(' ', [user?.surname, user?.firstName || user?.firstname]);

	const finalSellersIn = useMemo(() => {
		if (user?.sellersIn) {
			return !isNilOrEmpty(user?.sellersIn)
				? user.sellersIn.map((sellerIn) => <div key={sellerIn}>{sellerIn}</div>)
				: equalOrThreeDashes();
		}

		if (user?.sellerInList) {
			if (isNilOrEmptyString(user?.sellerInList)) {
				return equalOrThreeDashes();
			} else {
				const sellerInArray = user?.sellerInList.split(',');
				return sellerInArray.map((sellerIn) => <div key={sellerIn}>{sellerIn}</div>);
			}
		}
	}, [user?.sellersIn, user?.sellerInList]);

	return (
		<>
			<TableCell>
				<Link underline="none" data-user={index} id="tableCellUserSelect" onClick={onSelect}>
					{fullName}
				</Link>
			</TableCell>
			<TableCell>{equalOrThreeDashes(user.login || user.userLogin)}</TableCell>
			<TableCell>
				{
					finalSellersIn

					// user.sellersIn
					// 	? user.sellersIn.map((sellerIn) => <div key={sellerIn}>{sellerIn}</div>)
					// 	: equalOrThreeDashes(user.sellerIn)
				}
			</TableCell>
			<TableCell>{equalOrThreeDashes(user.profession)}</TableCell>
		</>
	);
};

Row.propTypes = {
	index: PropTypes.number,
	onSelect: PropTypes.func,
	user: PropTypes.object,
};

export default memo(Row);
